import { useState, useEffect } from 'react'
import { WifiOff, Wifi } from 'lucide-react'
import { cn } from '@/lib/utils'
import { wsManager } from '@/lib/websocket-manager'

export function ConnectionStatus() {
  const [isConnected, setIsConnected] = useState(true)
  const [showStatus, setShowStatus] = useState(false)
  
  useEffect(() => {
    const handleReconnected = () => {
      setIsConnected(true)
      // Show success briefly
      setShowStatus(true)
      setTimeout(() => setShowStatus(false), 3000)
    }
    
    const handleConnectionError = () => {
      setIsConnected(false)
      setShowStatus(true)
    }
    
    const handleOnline = () => {
      if (!isConnected) {
        console.log('[ConnectionStatus] Network online, attempting reconnection')
        wsManager.forceReconnect()
      }
    }
    
    const handleOffline = () => {
      setIsConnected(false)
      setShowStatus(true)
    }
    
    // Listen for WebSocket events
    window.addEventListener('wsReconnected', handleReconnected)
    window.addEventListener('wsConnectionError', handleConnectionError)
    window.addEventListener('online', handleOnline)
    window.addEventListener('offline', handleOffline)
    
    // Check initial connection state
    if (!navigator.onLine) {
      setIsConnected(false)
      setShowStatus(true)
    }
    
    return () => {
      window.removeEventListener('wsReconnected', handleReconnected)
      window.removeEventListener('wsConnectionError', handleConnectionError)
      window.removeEventListener('online', handleOnline)
      window.removeEventListener('offline', handleOffline)
    }
  }, [isConnected])
  
  if (!showStatus && isConnected) {
    return null
  }
  
  return (
    <div className={cn(
      "fixed bottom-0 left-0 right-0 z-[100]",
      "flex justify-center p-4"
    )}>
      <div className={cn(
        "bg-white/80 backdrop-blur-md border border-gray-100/50",
        "rounded-full px-4 py-2",
        "flex items-center gap-2 shadow-lg",
        "animate-in slide-in-from-bottom-5 duration-300",
        "text-xs font-medium max-w-fit"
      )}>
        {isConnected ? (
          <>
            <Wifi className="h-4 w-4 text-green-600" />
            <span className="text-green-700">Connected</span>
          </>
        ) : (
          <>
            <WifiOff className="h-4 w-4 text-orange-600" />
            <span className="text-orange-700">
              {navigator.onLine ? 'Reconnecting...' : 'Offline'}
              {wsManager.getIsIOSPWA() && ' (iOS PWA)'}
            </span>
          </>
        )}
      </div>
    </div>
  )
}